import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const asset = (url) => (url && url.startsWith("/api") ? `${BACKEND_URL}${url}` : url);

// Returns a smaller thumbnail variant of an image URL for grid/list use.
// - Our own uploads (/api/files/...) get an on-the-fly resized WebP via ?w=
// - Unsplash/Pexels URLs get their width + quality params trimmed down
// Full-resolution originals should still use asset() (e.g. in a lightbox).
export const thumb = (url, w = 800) => {
  if (!url) return url;
  if (url.startsWith("/api/files/")) return `${BACKEND_URL}${url}?w=${w}`;
  if (/images\.unsplash\.com/.test(url)) {
    const u = new URL(url);
    u.searchParams.set("w", String(w));
    u.searchParams.set("q", "70");
    return u.toString();
  }
  if (/images\.pexels\.com/.test(url)) {
    const u = new URL(url);
    u.searchParams.set("w", String(w));
    u.searchParams.set("dpr", "1");
    return u.toString();
  }
  return asset(url);
};

export const api = axios.create({ baseURL: API });

export const TOKEN_KEY = "as_admin_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

// Axios instance that always attaches the admin bearer token
export const adminApi = axios.create({ baseURL: API });
adminApi.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// Staff (ops) area — separate shared-password gate
export const STAFF_TOKEN_KEY = "as_staff_token";
export const getStaffToken = () => localStorage.getItem(STAFF_TOKEN_KEY);
export const setStaffToken = (t) => localStorage.setItem(STAFF_TOKEN_KEY, t);
export const clearStaffToken = () => localStorage.removeItem(STAFF_TOKEN_KEY);

export const staffApi = axios.create({ baseURL: API });
staffApi.interceptors.request.use((config) => {
  const t = getStaffToken() || getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});
